import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import locale from 'element-plus/dist/locale/zh-cn.mjs'
import * as ElIcons from '@element-plus/icons-vue'
import VueSocketIO from 'vue-socket-kevin.io';
import pinia from './stores'
import 'animate.css';
import i18n from './locales'

// 创建Vue应用实例（先不挂载）
const app = createApp(App)

// 注册第三方插件（包括Pinia）
app.use(pinia) // 必须先注册Pinia

// 注册ElementPlus
app.use(ElementPlus, {locale})

// 注册路由
app.use(router)
app.use(i18n)

// 注册Socket
const socket = new VueSocketIO({
    connection: 'https://notice.diydodo.com/',
});
app.use(socket)

// 注册Element图标
for (const name in ElIcons){
    app.component(name, ElIcons[name])
}

// 处理favicon函数
function setFavicon(url) {
    const existingLinks = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');
    existingLinks.forEach(link => link.remove());

    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = url;
    document.head.appendChild(link);
}

// 现在可以安全地使用Pinia store
import {saasStore} from "@/stores/modules/companyConfig";
const saasStore1 = saasStore()

// 异步初始化配置
async function initApp() {
    try {
        // 获取配置
        const config = await saasStore1.getSaasObj();

        console.log('config', config)

        // 设置favicon
        if (config.website.browserFileCode) setFavicon(config.website.browserFileCode);

        // // 设置标题
        // if (config.companyName) document.title = config.companyName;

        // 挂载应用
        app.mount('#app');

    } catch (error) {
        console.error("Failed to load configuration", error);
        // 使用默认配置挂载
        app.mount('#app');
    }
}

// 开始初始化
initApp();